/**
 * Backfill `is_closed` / `is_oneway` on pipes that predate the `defaultPipeFields` fix.
 *
 * ⚠️ Both are REQUIRED by `PipeEdgeSchema` (`z.boolean()`, not optional). `createPipe` has
 * always set them, but every hand-built edge in the app spread `defaultPipeFields`, which
 * omitted them — so pipes drawn in-app were schema-invalid from birth. Nothing validates on
 * save, so the model looked fine until something re-validated it:
 *   • POST /device-library → HTTP 400 "Invalid request body"
 *   • library insert → `HydraulicSystemSchema.safeParse` fails on the WHOLE system, so the
 *     UI reports "This saved item isn't compatible with the current model" — blaming the
 *     saved item for the host model's bad data.
 *
 * This repairs legacy rows written by our own bug, using the SAME default `createPipe` has
 * always used (false = not closed, not one-way). It is not a guess about unknown input:
 * absent has only ever meant false here. An explicit value is never overwritten.
 *
 * Mutates the edges in place (callers pass freshly-cloned arrays) and returns them.
 */
export function normalizeLegacyPipeFlags<T>(edges: T[]): T[] {
  for (const e of edges) {
    const edge = e as unknown as Record<string, unknown>
    if (edge['type'] !== 'pipe' && edge['type'] !== 'compressible_pipe') continue
    if (edge['is_closed'] === undefined) edge['is_closed'] = false
    if (edge['is_oneway'] === undefined) edge['is_oneway'] = false
  }
  return edges
}
